import jwtDecode from "jwt-decode";
import * as R from "ramda";

import {
  UPDATE_USER_PROFILE,
  FETCH_USER_CALENDARS,
  FETCH_USER_PROFILE,
  UPDATE_USER_PREFERENCES,
  SELECT_USER_CALENDAR,
  CONNECT_USER_SOCIAL_ACCOUNT,
  DISCONNECT_USER_SOCIAL_ACCOUNT
} from "../actions/user";
import { LOGIN } from "../actions/session";

const token = localStorage.getItem("token");

export const initialState = R.ifElse(
  R.isNil,
  R.always({}),
  R.pipe(
    token => jwtDecode(token),
    R.prop("data"),
    R.applySpec({
      id: R.prop("id"),
      roles: R.prop("roles")
    })
  )
)(token);

const user = (state = initialState, { type, payload }) => {
  switch (type) {
    case CONNECT_USER_SOCIAL_ACCOUNT.STARTED:
      return R.assocPath(["socialAccounts", "loading"], payload.provider)(
        state
      );

    case DISCONNECT_USER_SOCIAL_ACCOUNT.STARTED:
      return R.assocPath(["socialAccounts", "loading"], payload)(state);
    case DISCONNECT_USER_SOCIAL_ACCOUNT.REJECTED:
    case CONNECT_USER_SOCIAL_ACCOUNT.REJECTED:
      return R.assocPath(["socialAccounts", "loading"], null)(state);
    case CONNECT_USER_SOCIAL_ACCOUNT.RESOLVED:
    case DISCONNECT_USER_SOCIAL_ACCOUNT.RESOLVED:
      return {
        ...payload
      };
    case UPDATE_USER_PREFERENCES.RESOLVED:
    case UPDATE_USER_PROFILE.RESOLVED:
    case SELECT_USER_CALENDAR.RESOLVED:
    case FETCH_USER_CALENDARS.RESOLVED:
    case FETCH_USER_PROFILE.RESOLVED:
      return { ...state, ...payload };
    case LOGIN.RESOLVED: {
      return {
        ...state,
        id: payload.id,
        email: payload.email,
        roles: payload.roles
      };
    }
    default:
      return state;
  }
};

export default user;
